import type { BankingProduct } from '@models/loyalty-libs';

import { createAction, props } from '@ngrx/store';

export const getBankingProductList = createAction('[BankingProducts] Get All', props<{ partnerId: string }>());
export const setBankingProductList = createAction(
  '[BankingProducts] Set',
  props<{ bankingProducts: BankingProduct[] }>()
);
export const deleteBankingProduct = createAction('[BankingProducts] Delete One', props<{ bankingProductId: string }>());
export const deleteBankingProductSuccess = createAction(
  '[BankingProducts] Delete One Success',
  props<{ bankingProductId: string }>()
);

export const deleteBankingProductFailure = createAction(
  '[Banking Product] Delete Banking Product Failure',
  props<{ error: string; bankingProductId: string }>()
);
